import React from "react";
import { Range } from "react-range";
import "./RangeInput.scss";
import classNames from "classnames";

interface Props {
  label?: string;
  values: number[];
  onChange: (e: number[]) => void;
  disabled?: boolean;
  hasError?: boolean;
  step: number;
  min: number;
  max: number;
}

const RangeInput: React.FC<Props> = ({
  label,
  values,
  onChange,
  disabled,
  hasError,
  step,
  min,
  max,
}) => {
  return (
    <div
      className={classNames("range-input", {
        "range-input--disabled": disabled,
        "range-input--error": hasError && !disabled,
      })}
    >
      {label && (
        <div className="range-input__header">
          <div className="range-input__label">{label}:</div>
          <span className="range-input__value">
            {values[0].toLocaleString()}
          </span>
        </div>
      )}
      <Range
        disabled={disabled}
        step={step}
        min={min}
        max={max}
        values={values}
        onChange={(values) => onChange(values)}
        renderTrack={({ props, children }) => (
          <div {...props} className="range-input__track">
            {children}
          </div>
        )}
        renderThumb={({ props }) => (
          <div {...props} className="range-input__thumb" />
        )}
      />
    </div>
  );
};

export default RangeInput;
